<div class="ogc-filter-form-container">
  <mat-checkbox
    tooltip-position="below"
    matTooltipShowDelay="500"
    [matTooltip]="'igo.geo.filter.toggleFilterState' | translate"
    (click)="$event.stopPropagation()"
    (change)="toggleFilterState($event)"
    [checked]="currentFilter().active"
  />

  <mat-form-field
    [ngClass]="{
      logical:
        activeFilters.indexOf(currentFilter()) !== 0 &&
        currentFilter().active === true,
      logicalHidden:
        activeFilters.indexOf(currentFilter()) === 0 ||
        currentFilter().active !== true
    }"
  >
    <mat-select
      [disabled]="!currentFilter().active"
      [value]="currentFilter().parentLogical"
      tooltip-position="above"
      matTooltipShowDelay="500"
      [matTooltip]="
        currentFilter().parentLogical
          ? ('igo.geo.operators.tooltip.' + currentFilter().parentLogical
            | translate)
          : ''
      "
      (selectionChange)="changeLogical($event.value)"
    >
      <mat-option
        [value]="ogcFilterOperator.And"
        tooltip-position="above"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.operators.tooltip.And' | translate"
      >
        {{ 'igo.geo.operators.And' | translate }}
      </mat-option>
      <mat-option
        [value]="ogcFilterOperator.Or"
        tooltip-position="above"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.operators.tooltip.Or' | translate"
      >
        {{ 'igo.geo.operators.Or' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  @if (
    (currentFilterIsSpatial$ | async) === false &&
    (fields$ | async) &&
    (fields$ | async).length > 0 &&
    (fields$ | async)[0].name !== ''
  ) {
    <mat-form-field
      class="field"
      (mouseenter)="inputClearable = 'selectField'"
      (mouseleave)="inputClearable = undefined"
      [floatLabel]="floatLabel()"
    >
      <input
        matInput
        [placeholder]="'igo.geo.sourceFields.selectField' | translate"
        [disabled]="!currentFilter().active"
        [matAutocomplete]="autoCompleteField"
        [value]="(selectedField$ | async) ? (selectedField$ | async).alias : ''"
        tooltip-position="above"
        matTooltipShowDelay="500"
        [matTooltip]="
          (selectedField$ | async)
            ? (selectedField$ | async).alias
            : ('igo.geo.sourceFields.selectField' | translate)
        "
        (input)="updateFieldsList($any($event.target).value)"
      />
      <mat-autocomplete
        #autoCompleteField="matAutocomplete"
        (optionSelected)="changeField($event.option.id)"
      >
        @for (field of filteredFields$ | async; track field) {
          <mat-option
            matTooltipShowDelay="500"
            [value]="field.alias"
            [id]="field.name"
            [matTooltip]="field.alias"
          >
            {{ field.alias }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (
        currentFilter().propertyName &&
        inputClearable === 'selectField' &&
        currentFilter().active
      ) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          [disabled]="!currentFilter().active"
          (click)="clearSelectedField()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }

  <mat-form-field
    [ngClass]="{
      operator: (currentFilterIsSpatial$ | async) === false,
      dualInput: (currentFilterIsSpatial$ | async)
    }"
    [floatLabel]="floatLabel()"
  >
    <mat-select
      tooltip-position="below"
      matTooltipShowDelay="500"
      [matTooltip]="
        currentFilter().operator
          ? ('igo.geo.operators.tooltip.' + currentFilter().operator
            | translate)
          : ('igo.geo.filter.selectOperator' | translate)
      "
      [disabled]="!currentFilter().active"
      [value]="currentFilter().operator"
      (selectionChange)="changeOperator($event.value)"
    >
      @for (
        operator of ogcFilterOperators$ | async | keyvalue;
        track operator
      ) {
        <mat-option
          tooltip-position="above"
          matTooltipShowDelay="500"
          [value]="operator.key"
          [matTooltip]="'igo.geo.operators.tooltip.' + operator.key | translate"
        >
          {{ 'igo.geo.operators.' + operator.key | translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (currentFilterIsSpatial$ | async) {
    <mat-form-field class="spatialSelector">
      <mat-select
        [disabled]="!currentFilter().active"
        [value]="currentFilter().igoSpatialSelector"
        (selectionChange)="changeSpatialSelector($event.value)"
      >
        @for (
          igoSpatialSelector of igoSpatialSelectors;
          track igoSpatialSelector
        ) {
          <mat-option [value]="igoSpatialSelector.type">
            {{
              'igo.geo.spatialSelector.' + igoSpatialSelector.type | translate
            }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (['expression', 'pattern'].indexOf(detectProperty()) !== -1) {
    <mat-form-field
      class="singleInput"
      (mouseenter)="inputClearable = 'selectProperty'"
      (mouseleave)="inputClearable = undefined"
      [floatLabel]="floatLabel()"
    >
      <input
        matInput
        [placeholder]="'igo.geo.filter.placeholder' | translate"
        [disabled]="!currentFilter().active"
        [matAutocomplete]="autoCompleteValues"
        [value]="
          detectProperty() === 'expression'
            ? currentFilter().expression
            : currentFilter().pattern
        "
        tooltip-position="above"
        matTooltipShowDelay="500"
        [matTooltip]="
          detectProperty() === 'expression'
            ? currentFilter().expression || ''
            : currentFilter().pattern || ''
        "
        (input)="updateValuesList($any($event.target).value)"
      />
      <mat-autocomplete
        #autoCompleteValues="matAutocomplete"
        (optionSelected)="changeProperty($event.option.value)"
      >
        @for (value of filteredValues$ | async; track value) {
          <mat-option
            matTooltipShowDelay="500"
            [value]="value"
            [matTooltip]="value"
          >
            {{ value }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (
        isClearable() &&
        inputClearable === 'selectProperty' &&
        currentFilter().active
      ) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          [disabled]="!currentFilter().active"
          (click)="clearProperty()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }

  <div class="igo-layer-button-group">
    <button
      mat-icon-button
      collapsibleButton
      tooltip-position="below"
      matTooltipShowDelay="500"
      [matTooltip]="'igo.geo.filter.removeFilter' | translate"
      color="warn"
      (click)="deleteFilter()"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  @if (
    (currentFilterIsSpatial$ | async) &&
    currentFilter().igoSpatialSelector === 'snrc'
  ) {
    <mat-form-field
      class="snrc"
      (mouseenter)="inputClearable = 'selectSNRC'"
      (mouseleave)="inputClearable = undefined"
      [floatLabel]="floatLabel()"
    >
      <input
        matInput
        [placeholder]="'igo.geo.filter.placeholderSnrc' | translate"
        [value]="currentFilter().igoSNRC"
        tooltip-position="above"
        matTooltipShowDelay="500"
        [matTooltip]="currentFilter().igoSNRC ? currentFilter().igoSNRC : ''"
        (input)="changeSNRC($any($event.target).value)"
      />
      @if (currentFilter().igoSNRC) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          [disabled]="
            !currentFilter().active &&
            inputClearable === 'selectSNRC' &&
            currentFilter().active
          "
          (click)="clearSNRC()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }

  @if (
    (currentFilterIsSpatial$ | async) &&
    currentFilter().igoSpatialSelector === 'fixedExtent'
  ) {
    @if (currentFilter().igoSpatialSelector === 'fixedExtent') {
      <button
        [disabled]="!currentFilter().active"
        matSuffix
        mat-icon-button
        [disabled]="!currentFilter().active"
        (click)="changeMapExtentGeometry()"
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.spatialSelector.btnSetExtent' | translate"
      >
        <mat-icon>zoom_out_map</mat-icon>
      </button>
    }
  }
</div>

<div class="ogc-filter-form-container">
  @if (
    !isTemporalOperator() &&
    ['lowerBoundary', 'begin'].indexOf(detectProperty(1)) !== -1
  ) {
    <mat-form-field
      class="dualInput"
      (mouseenter)="inputClearable = 'selectProperty1'"
      (mouseleave)="inputClearable = undefined"
      [floatLabel]="floatLabel()"
    >
      <input
        matInput
        [placeholder]="'igo.geo.filter.placeholder' | translate"
        [disabled]="!currentFilter().active"
        [matAutocomplete]="autoDualValueOperator1"
        type="number"
        [value]="
          detectProperty(1) === 'lowerBoundary'
            ? currentFilter().lowerBoundary
            : currentFilter().begin
        "
        (input)="updateValuesList($any($event.target).value, 1)"
      />
      <mat-autocomplete
        #autoDualValueOperator1="matAutocomplete"
        (optionSelected)="changeNumericProperty($event.option.value, 1)"
      >
        @for (value of filteredValues$ | async; track value) {
          <mat-option
            matTooltipShowDelay="500"
            [value]="value"
            [matTooltip]="value"
          >
            {{ value }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (
        isClearable(1) &&
        inputClearable === 'selectProperty1' &&
        currentFilter().active
      ) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          [disabled]="!currentFilter().active"
          (click)="clearProperty(1)"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }

  @if (
    !isTemporalOperator() &&
    ['upperBoundary', 'end'].indexOf(detectProperty(2)) !== -1
  ) {
    <mat-form-field
      class="dualInput"
      (mouseenter)="inputClearable = 'selectProperty2'"
      (mouseleave)="inputClearable = undefined"
      [floatLabel]="floatLabel()"
    >
      <input
        matInput
        [placeholder]="'igo.geo.filter.placeholder' | translate"
        [disabled]="!currentFilter().active"
        [matAutocomplete]="autoDualValueOperator2"
        type="number"
        [value]="
          detectProperty(2) === 'upperBoundary'
            ? currentFilter().upperBoundary
            : currentFilter().end
        "
        (input)="updateValuesList($any($event.target).value, 2)"
      />
      <mat-autocomplete
        #autoDualValueOperator2="matAutocomplete"
        (optionSelected)="changeNumericProperty($event.option.value, 2)"
      >
        @for (value of filteredValues$ | async; track value) {
          <mat-option
            matTooltipShowDelay="500"
            [value]="value"
            [matTooltip]="value"
          >
            {{ value }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (
        isClearable(2) &&
        inputClearable === 'selectProperty2' &&
        currentFilter().active
      ) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          [disabled]="!currentFilter().active"
          (click)="clearProperty(2)"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }
</div>

@if (isTemporalOperator()) {
  <igo-ogc-filter-time
    [datasource]="datasource()"
    [currentFilter]="currentFilter()"
    (changeProperty)="changeProperty($event.value, $event.pos)"
  />
}
